import React, { useEffect, useState } from "react";
import VideoStopOverlayIcon from "@atlaskit/icon/core/video-stop-overlay";
import Button from "@atlaskit/button/new";
import { useDispatch, useSelector } from "react-redux";
import { stopFlowExecution } from "../../redux/actions/integrationActions";
import { FLOW_RUNNER_PENDING_EVENT } from "../FlowRunner";

const StopFlowButton = () => {
  const dispatch = useDispatch();
  const flow = useSelector((state) => state.integration.flow);
  const flowRunnerStatuses = useSelector((state) => state.integration.flowRunnerStatuses || {});
  const flowId = flow?.id;
  const [isRunning, setIsRunning] = useState(false);
  const [isStopping, setIsStopping] = useState(false);

  const dispatchFlowRunnerPendingStatus = (status, durationMs = 30000) => {
    if (typeof window === "undefined" || !flowId) {
      return;
    }

    const detail = {
      flowId,
      status,
      durationMs,
    };

    if (typeof CustomEvent === "function") {
      window.dispatchEvent(new CustomEvent(FLOW_RUNNER_PENDING_EVENT, { detail }));
    } else if (typeof document !== "undefined" && document.createEvent) {
      const event = document.createEvent("CustomEvent");
      event.initCustomEvent(FLOW_RUNNER_PENDING_EVENT, false, false, detail);
      window.dispatchEvent(event);
    }
  };

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const handlePendingRunEvent = (event) => {
      const detail = event?.detail;
      if (!detail || detail.flowId !== flowId) {
        return;
      }

      if (detail.status === "STOPPING") {
        setIsStopping(true);
        setIsRunning(false);
        return;
      }

      if (detail.status === "RUNNING") {
        setIsStopping(false);
        setIsRunning(true);
      }
    };

    window.addEventListener(FLOW_RUNNER_PENDING_EVENT, handlePendingRunEvent);
    return () => {
      window.removeEventListener(FLOW_RUNNER_PENDING_EVENT, handlePendingRunEvent);
    };
  }, [flowId]);

  useEffect(() => {
    const currentStatuses = flowId ? flowRunnerStatuses[flowId] : null;
    const latestStatus = Array.isArray(currentStatuses) ? currentStatuses[0] : null;
    const isCurrentlyRunning = latestStatus?.status === "RUNNING";

    if (!isCurrentlyRunning) {
      setIsStopping(false);
      setIsRunning(false);
      return;
    }

    if (!isStopping) {
      setIsRunning(true);
    }
  }, [flowId, flowRunnerStatuses, isStopping]);

  const stopFlow = () => {
    if (flow) {
      setIsStopping(true);
      setIsRunning(false);
      dispatchFlowRunnerPendingStatus("STOPPING");
      dispatch(stopFlowExecution(flow));
    }
  };

  return (
    <>
      {isRunning && (
        <Button onClick={stopFlow} isDisabled={!flow.enabled}>
          <VideoStopOverlayIcon label="Stop flow" color="#c9382d" />
        </Button>
      )}
    </>
  );
};
export default StopFlowButton;
